export default __webpack_public_path__ + "static/media/alerts.220a472e.svg";